export default __webpack_public_path__ + "static/media/profielfoto.79e3248c.jpg";